export const UPDATES_PER_BLOCK = {
  CRITICAL_DATA: 30,
  SEMI_CRITICAL: 50,
  NOT_CRITICAL: 200,
  DO_NOT_UPDATE: 10000,
}
